"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const formik_1 = require("formik");
const react_1 = require("react");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const sign_up_1 = require("../../network/sign-up");
const password_field_1 = require("../../component/input/password-field");
const react_router_dom_1 = require("react-router-dom");
const material_2 = require("@mui/material");
const email_varify_1 = require("../../network/email-varify");
const alert_context_1 = require("../../context/alert-context");
const button_1 = require("../../component/input/button");
const log_1 = require("../../model/log");
const log_view_layout_1 = require("../../component/log-view-layout");
exports.SignUpPage = (0, react_1.memo)(() => {
    const theme = (0, material_1.useTheme)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { result, status, execute, error } = (0, use_lazy_promise_1.useLazyPromise)(sign_up_1.signUp);
    const [userConsent, setUserConsent] = (0, react_1.useState)(false);
    const [count, setCount] = (0, react_1.useState)(0);
    const { status: sendCodeStatus, execute: executeSendCode } = (0, use_lazy_promise_1.useLazyPromise)(email_varify_1.sendCode);
    const { showAlert } = (0, alert_context_1.useAlert)();
    const formik = (0, formik_1.useFormik)({
        initialValues: {
            email: "",
            validationCode: "",
            password: "",
            confirmPassword: "",
        },
        validateOnChange: false,
        validateOnBlur: false,
        validate: (values) => {
            const errors = {};
            if (!/\S+@\S+\.\S+/.test(values.email)) {
                errors.email = "Email is invalid";
                return errors;
            }
            if (values.validationCode.length === 0) {
                errors.validationCode = "Validation code is required";
                return errors;
            }
            if (values.password.length < 6) {
                errors.password = "Password must be at least 6 characters";
                return errors;
            }
            if (values.password !== values.confirmPassword) {
                errors.confirmPassword = "Passwords do not match";
                return errors;
            }
        },
        onSubmit: (values) => {
            execute(values.email, values.password, values.validationCode);
        },
    });
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Success) {
            navigate("/home");
        }
    }, [result, status, formik, navigate]);
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Error) {
            showAlert((error === null || error === void 0 ? void 0 : error.message) || "Sign up failed", alert_context_1.AlertType.Error);
        }
    }, [status, error, showAlert]);
    const handleSignIn = (0, react_1.useCallback)(() => {
        navigate("/sign-in");
    }, [navigate]);
    const submitEnabled = (0, react_1.useMemo)(() => {
        return (userConsent &&
            formik.values.email.length > 0 &&
            formik.values.validationCode.length > 0 &&
            formik.values.password.length > 0 &&
            formik.values.confirmPassword.length > 0);
    }, [
        userConsent,
        formik.values.email.length,
        formik.values.validationCode.length,
        formik.values.password.length,
        formik.values.confirmPassword.length,
    ]);
    const handleUserConsentChanged = (0, react_1.useCallback)((event) => {
        setUserConsent(event.target.checked);
    }, []);
    const startCountdown = (0, react_1.useCallback)(() => {
        setCount(60);
        const interval = setInterval(() => {
            setCount((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    const handleSendCode = (0, react_1.useCallback)(() => {
        executeSendCode(formik.values.email);
    }, [executeSendCode, formik.values.email]);
    (0, react_1.useEffect)(() => {
        if (sendCodeStatus === use_lazy_promise_1.FetchStatus.Success) {
            startCountdown();
        }
    }, [sendCodeStatus, startCountdown]);
    (0, react_1.useCallback)(() => {
        if (sendCodeStatus === use_lazy_promise_1.FetchStatus.Error) {
            showAlert("Failed to send verification code. Please try again.", alert_context_1.AlertType.Error);
        }
    }, [sendCodeStatus, showAlert]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { overflow: "auto", direction: "column", alignItems: "center", justifyContent: "center", style: {
            flexGrow: 1,
        }, paddingY: 8, children: [(0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.SignUpPage }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", fontWeight: theme.typography.fontWeightBold, color: "primary", marginBottom: theme.spacing(4), textAlign: "center", children: "Sign Up" }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", spacing: 4, width: theme.spacing(50), children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Email", variant: "outlined", value: formik.values.email, onChange: formik.handleChange, error: Boolean(formik.errors.email), helperText: formik.errors.email, name: "email", fullWidth: true }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", width: "100%", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { label: "verification code", variant: "outlined", value: formik.values.validationCode, onChange: formik.handleChange, error: Boolean(formik.errors.validationCode), helperText: formik.errors.validationCode, name: "validationCode", sx: { minWidth: "70%" } }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "text", color: "primary", onClick: handleSendCode, eventName: log_1.LogEventClickName.SignUpPageSendCode, startIcon: sendCodeStatus === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "primary" })), disabled: !formik.values.email || Boolean(formik.errors.email) || count > 0, children: count > 0 ? `${count}s` : "Send Code" })] }), (0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "Password", variant: "outlined", type: "password", value: formik.values.password, onChange: formik.handleChange, error: Boolean(formik.errors.password), helperText: formik.errors.password, name: "password", fullWidth: true }), (0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "Confirm Password", variant: "outlined", type: "password", value: formik.values.confirmPassword, onChange: formik.handleChange, error: formik.errors.confirmPassword !== undefined, helperText: formik.errors.confirmPassword, name: "confirmPassword", fullWidth: true }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "large", variant: "outlined", color: "primary", fullWidth: true, eventName: log_1.LogEventClickName.SignInPageSignUp, startIcon: status === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "primary" })), disabled: !submitEnabled, onClick: formik.submitForm, children: "Continue" }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 2, width: "100%", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_2.Checkbox, { checked: userConsent, onChange: handleUserConsentChanged }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body2", color: "textSecondary", children: [`By createing an account, you agree to our`, (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/terms", target: "_blank", rel: "noopener noreferrer", style: {
                                            textDecoration: "none",
                                            color: theme.palette.primary.main,
                                        }, children: "Terms of Service" }), ` and `, (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/privacy", target: "_blank", rel: "noopener noreferrer", style: {
                                            textDecoration: "none",
                                            color: theme.palette.primary.main,
                                        }, children: "Privacy Policy" }), "."] })] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "center", width: "100%", spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "textSecondary", children: "Already have an account?" }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "text", color: "primary", eventName: log_1.LogEventClickName.SignUpPageSignIn, onClick: handleSignIn, children: "Sign In" })] })] })] }));
});
exports.SignUpPage.displayName = "SignUpPage";
exports.default = exports.SignUpPage;
